import React from 'react';
import { NavLink } from 'react-router-dom';
import { Activity, Grid3x3, Gauge, Waves } from 'lucide-react';
import { MidiButton } from './MidiSettings';

const LINKS = [
  { to: '/', id: 'home', label: 'Player', Icon: Activity },
  { to: '/sequencer', id: 'sequencer', label: 'Sequencer', Icon: Grid3x3 },
  { to: '/tuner', id: 'tuner', label: 'Tuner', Icon: Gauge },
  { to: '/bordone', id: 'bordone', label: 'Bordone', Icon: Waves },
];

// Shared top navigation bar — visible on all pages.
// Mobile-friendly: compact, sticky-ready, large touch targets.
export default function TopNav() {
  const baseLinkCls = 'px-2.5 min-[360px]:px-3 sm:px-4 py-2 rounded-full text-[11px] sm:text-xs uppercase tracking-[0.2em] flex items-center gap-1.5 sm:gap-2 transition-all whitespace-nowrap select-none';
  const inactive = 'text-white/55 hover:text-white hover:bg-white/5';
  const active = 'bg-pink-400 text-black shadow-[0_0_18px_rgba(236,72,153,0.35)]';

  return (
    <nav
      data-testid="top-nav"
      className="sticky top-0 z-40 -mx-4 md:-mx-8 mb-2 px-4 md:px-8 py-2 sm:py-3 bg-[#0A0A0A]/85 backdrop-blur-xl border-b border-white/5"
      style={{ paddingTop: 'max(0.5rem, env(safe-area-inset-top))' }}
    >
      <div className="max-w-6xl mx-auto flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 sm:gap-3 shrink-0">
          <div className="font-bebas text-xl sm:text-3xl tracking-wide text-white leading-none">
            Metronomo<span className="text-pink-400">.</span>
          </div>
        </div>
        <div className="flex items-center gap-1 sm:gap-2 overflow-x-auto no-scrollbar -mx-1 px-1">
          {LINKS.map(({ to, id, label, Icon }) => (
            <NavLink
              key={to}
              to={to}
              end
              aria-label={label}
              data-testid={`nav-link-${id}`}
              className={({ isActive }) => `${baseLinkCls} ${isActive ? active : inactive}`}
            >
              {({ isActive }) => (
                <>
                  <Icon className="w-3.5 h-3.5" />
                  <span className={isActive ? 'hidden min-[360px]:inline' : 'hidden sm:inline'}>{label}</span>
                </>
              )}
            </NavLink>
          ))}
          <MidiButton />
        </div>
      </div>
    </nav>
  );
}
